import { render, staticRenderFns } from "./Right.vue?vue&type=template&id=52e035f6"
import script from "./Right.vue?vue&type=script&lang=js"
export * from "./Right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports